import mailIcon from "../assets/icons/email_icon.png";

function Footer() {
    const email = "info@scarlettummers.com";
    return (
        <section className="contact main-section" id="contact">
            <h3 className="contact-heading">Contact</h3>
            <a className="link-mail" href={`mailto:${email}`}>
                <img className="footer-icon" src={mailIcon} alt="" />
                {email}
            </a>
        </section>
    );
}

export default Footer;
